module.exports = __webpack_public_path__ + "static/media/sllide6.13543783.png";